import styled from '@emotion/styled'
import { css } from '@emotion/react'

export const StyledTypography = styled.p<any>`
  color: ${(props) => props.theme.colors[props.tc || 'primaryText']};
  font-weight: ${(props) => props?.weigth || 500};
  ${({ size, lineHeight }) => css`
    ${size && `font-size: ${size}px;`}
    ${lineHeight && `line-height: ${lineHeight}px;`}
  `}
  ${(props) => props.styleText && props.styleText}
`
